/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import { vappContainer } from '@/application';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
//import { LandingPage } from '@pages/ProductLandingPage/widget/landing-page-widget';
import { LandingPage } from '@widgets/landing-page-widget';
// import { CustomMetaTags } from "@pages/ProductLandingPage/widget/custom-meta-titles";
import { useTheme } from '../../../providers/theme';

import { useSMGetProductPageData } from '@pages/ProductLandingPage/machines/get-landing';

import { LandingPageService } from '@pages/ProductLandingPage/services';

const getSrv = () => {
  return vappContainer.get<LandingPageService>(LandingPageService.displayName);
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const [buttonItem, setButtonItem] = useState();
  const srv = getSrv();

  useEffect(() => {
    async function getNavItems() {
      let _navlinks = await srv?.agent?.getHeaderNavItemsSync();
      console.log(`nav items`, _navlinks);
      if (_navlinks) {
        setButtonItem(_navlinks);
      }
    }
    setTimeout(() => {
      getNavItems();
    }, 500);
  }, []);

  const {
    getProductPageDataMachine,
    getProductPageDataMachineSend,
    getProductPageDataMachineState,
  } = useSMGetProductPageData({});

  const _renderPage = () => {
    if (getProductPageDataMachineState?.matches('RENDER_PRODUCT_PAGE_DATA')) {
      return (
        <>
          {/* <CustomMetaTags
            {...(getProductPageDataMachineState?.event?.data?.value?.metaData || {})}
          /> */}
          <LandingPage
            {...(getProductPageDataMachineState?.event?.data?.value || {})}
            buttonItem={buttonItem}
          />
        </>
      );
    }
    if (getProductPageDataMachineState?.matches('GET_PRODUCT_PAGE_DATA')) {
      return (
        <StateOSD
          {...(srv?.agent?.getLoadingContentSync()?.loading?.pageLoading || {})}
        />
      );
    }
  };
  return <>{_renderPage()}</>;
};
